/**
 *
 * @param {string} name
 * @returns
 */

import key from "./key"

const url = `app/${key}`

export const LOAD_RECORDS = `${url}/LOAD_RECORDS`
export const LOAD_RECORDS_SUCCESS = `${url}/LOAD_RECORDS_SUCCESS`
export const LOAD_RECORDS_ERROR = `${url}/LOAD_RECORDS_ERROR`
export const LOAD_RECORD = `${url}/LOAD_RECORD`
export const LOAD_CLIENT_RECORD = `${url}/LOAD_CLIENT_RECORD`
export const LOAD_RECORD_SUCCESS = `${url}/LOAD_RECORD_SUCCESS`
export const LOAD_RECORD_ERROR = `${url}/LOAD_RECORD_ERROR`
export const LOAD_RECORD_CLIENT_DETAILS = `${url}/LOAD_RECORD_CLIENT_DETAILS`
export const LOAD_RECORD_CLIENT_PROFILE_BY_ID = `${url}/LOAD_RECORD_CLIENT_PROFILE_BY_ID`
export const LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS = `${url}/LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS`
export const LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR = `${url}/LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR`
export const LOAD_RECORD_CLIENT_DETAILS_SUCCESS = `${url}/LOAD_RECORD_CLIENT_DETAILS_SUCCESS`
export const LOAD_RECORD_CLIENT_DETAILS_ERROR = `${url}/LOAD_RECORD_CLIENT_DETAILS _ERROR`
export const LOAD_RECORD_CLIENT_DETAILS_META_DATA = `${url}/LOAD_RECORD_CLIENT_DETAILS_META_DATA`
export const LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS = `${url}/LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS`
export const LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR = `${url}/LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR`
export const CREATE_RECORD = `${url}/CREATE_RECORD`
export const UPDATE_CLIENT_PROFILE_RECORD = `${url}/UPDATE_CLIENT_PROFILE_RECORD`
export const UPDATE_CLIENT_PROFILE_RECORD_SUCCESS = `${url}/UPDATE_CLIENT_PROFILE_RECORD_SUCCESS`
export const UPDATE_CLIENT_PROFILE_RECORD_ERROR = `${url}/UPDATE_CLIENT_PROFILE_RECORD_ERROR`
export const CREATE_RECORD_SUCCESS = `${url}/CREATE_RECORD_SUCCESS`
export const CREATE_RECORD_ERROR = `${url}/CREATE_RECORD_ERROR`
export const UPDATE_RECORD = `${url}/UPDATE_RECORD`
export const UPDATE_RECORD_SUCCESS = `${url}/UPDATE_RECORD_SUCCESS`
export const UPDATE_RECORD_ERROR = `${url}/UPDATE_RECORD_ERROR`
export const DELETE_RECORD = `${url}/DELETE_RECORD`
export const DELETE_RECORD_SUCCESS = `${url}/DELETE_RECORD_SUCCESS`
export const DELETE_RECORD_ERROR = `${url}/DELETE_RECORD_ERROR`
export const UPDATE_CLIENT_RECORD = `${url}/UPDATE_CLIENT_RECORD`
export const UPDATE_CLIENT_RECORD_SUCCESS = `${url}/UPDATE_CLIENT_RECORD_SUCCESS`
export const UPDATE_CLIENT_RECORD_ERROR = `${url}/UPDATE_CLIENT_RECORD_ERROR`
export const DELETE_CLIENT_RECORD = `${url}/DELETE_CLIENT_RECORD`
export const DELETE_CLIENT_RECORD_SUCCESS = `${url}/DELETE_CLIENT_RECORD_SUCCESS`
export const DELETE_CLIENT_RECORD_ERROR = `${url}/DELETE_CLIENT_RECORD_ERROR`
export const LOAD_RECORDS_META_DATA = `${url}/LOAD_RECORDS_META_DATA`
export const LOAD_RECORDS_META_DATA_SUCCESS = `${url}/LOAD_RECORDS_META_DATA_SUCCESS`
export const LOAD_RECORDS_META_DATA_ERROR = `${url}/LOAD_RECORDS_META_DATA_ERROR`
export const LOAD_RECORDS_VALID_CACHE = `${url}/LOAD_RECORDS_VALID_CACHE`
export const UPDATE_STATUS = `${url}/UPDATE_STATUS`
export const UPDATE_STATUS_SUCCESS = `${url}/UPDATE_STATUS_SUCCESS`
export const UPDATE_STATUS_ERROR = `${url}/UPDATE_STATUS_ERROR`
export const UPDATE_CLIENT_STATUS = `${url}/UPDATE_CLIENT_STATUS`
export const UPDATE_CLIENT_STATUS_SUCCESS = `${url}/UPDATE_CLIENT_STATUS_SUCCESS`
export const UPDATE_CLIENT_STATUS_ERROR = `${url}/UPDATE_CLIENT_STATUS_ERROR`
export const LEAD_STATUS = `${url}/LEAD_STATUS`
export const LEAD_STATUS_SUCCESS = `${url}/LEAD_STATUS_SUCCESS`
export const LEAD_STATUS_ERROR = `${url}/LEAD_STATUS_ERROR`

//Client Profile questions list

export const LOAD_CLIENT_QUESTIONS_LIST = `${url}/LOAD_CLIENT_QUESTIONS_LIST`
export const LOAD_CLIENT_QUESTIONS_LIST_SUCCESS = `${url}/LOAD_CLIENT_QUESTIONS_LIST_SUCCESS`
export const LOAD_CLIENT_QUESTIONS_LIST_ERROR = `${url}/LOAD_CLIENT_QUESTIONS_LIST_ERROR`

export const LOAD_CLIENT_DETAILS_QUESTIONS_LIST = `${url}/LOAD_CLIENT_DETAILS_QUESTIONS_LIST`
export const LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS = `${url}/LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS`
export const LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR = `${url}/LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR`

export const ADD_CLIENT_QUESTIONS_LIST = `${url}/ADD_CLIENT_QUESTIONS_LIST`
export const ADD_CLIENT_QUESTIONS_LIST_SUCCESS = `${url}/ADD_CLIENT_QUESTIONS_LIST_SUCCESS`
export const ADD_CLIENT_QUESTIONS_LIST_ERROR = `${url}/ADD_CLIENT_QUESTIONS_LIST_ERROR`

export const NEW_LEAD_CREATION = `${url}/NEW_LEAD_CREATION`
export const NEW_LEAD_CREATION_SUCCESS = `${url}/NEW_LEAD_CREATION_SUCCESS`
export const NEW_LEAD_CREATION_ERROR = `${url}/NEW_LEAD_CREATION_ERROR`


export const ADD_CLIENT_COMPLETE = `${url}/ADD_CLIENT_COMPLETE`
export const ADD_CLIENT_COMPLETE_SUCCESS = `${url}/ADD_CLIENT_COMPLETE_SUCCESS`
export const ADD_CLIENT_COMPLETE_ERROR = `${url}/ADD_CLIENT_COMPLETE_ERROR`

export const ADD_CLIENT_APPEARANCE = `${url}/ADD_CLIENT_APPEARANCE`
export const ADD_CLIENT_APPEARANCE_SUCCESS = `${url}/ADD_CLIENT_APPEARANCE_SUCCESS`
export const ADD_CLIENT_APPEARANCE_ERROR = `${url}/ADD_CLIENT_APPEARANCE_ERROR`

export const UPDATE_CLIENT_TYPE = `${url}/UPDATE_CLIENT_TYPE`
export const UPDATE_CLIENT_TYPE_SUCCESS =  `${url}/UPDATE_CLIENT_TYPE_SUCCESS`
export const UPDATE_CLIENT_TYPE_ERROR =  `${url}/UPDATE_CLIENT_TYPE_ERROR`


export const UPDATE_ENGAGEMENT = `${url}/UPDATE_ENGAGEMENT`
export const UPDATE_ENGAGEMENT_SUCCESS =  `${url}/UPDATE_ENGAGEMENT_SUCCESS`
export const UPDATE_ENGAGEMENT_ERROR =  `${url}/UPDATE_ENGAGEMENT_ERROR`


export const UPDATE_HIGH_GOOD = `${url}/UPDATE_HIGH_GOOD`
export const UPDATE_HIGH_GOOD_SUCCESS =  `${url}/UPDATE_HIGH_GOOD_SUCCESS`
export const UPDATE_HIGH_GOOD_ERROR =  `${url}/UPDATE_HIGH_GOOD_ERROR`

const constants = {
  LOAD_RECORDS,
  LOAD_RECORDS_SUCCESS,
  LOAD_RECORDS_ERROR,
  LOAD_RECORD,
  LOAD_RECORD_SUCCESS,
  LOAD_RECORD_ERROR,
  LOAD_RECORD_CLIENT_DETAILS,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID_SUCCESS,
  LOAD_RECORD_CLIENT_PROFILE_BY_ID_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_SUCCESS,
  LOAD_RECORD_CLIENT_DETAILS_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA_ERROR,
  LOAD_RECORD_CLIENT_DETAILS_META_DATA_SUCCESS,
  CREATE_RECORD,
  UPDATE_CLIENT_PROFILE_RECORD,
  CREATE_RECORD_SUCCESS,
  CREATE_RECORD_ERROR,
  UPDATE_RECORD,
  UPDATE_RECORD_SUCCESS,
  UPDATE_RECORD_ERROR,
  DELETE_RECORD,
  DELETE_RECORD_SUCCESS,
  DELETE_RECORD_ERROR,
  UPDATE_CLIENT_RECORD,
  UPDATE_CLIENT_RECORD_SUCCESS,
  UPDATE_CLIENT_RECORD_ERROR,
  DELETE_CLIENT_RECORD,
  DELETE_CLIENT_RECORD_SUCCESS,
  DELETE_CLIENT_RECORD_ERROR,
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  UPDATE_STATUS,
  UPDATE_STATUS_SUCCESS,
  UPDATE_STATUS_ERROR,
  UPDATE_CLIENT_STATUS,
  UPDATE_CLIENT_STATUS_SUCCESS,
  UPDATE_CLIENT_STATUS_ERROR,
  LEAD_STATUS,
  LEAD_STATUS_SUCCESS,
  LEAD_STATUS_ERROR,

  //Client questions list
  LOAD_CLIENT_QUESTIONS_LIST,
  LOAD_CLIENT_QUESTIONS_LIST_SUCCESS,
  LOAD_CLIENT_QUESTIONS_LIST_ERROR,

  LOAD_CLIENT_DETAILS_QUESTIONS_LIST,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST_SUCCESS,
  LOAD_CLIENT_DETAILS_QUESTIONS_LIST_ERROR,

  ADD_CLIENT_QUESTIONS_LIST,
  ADD_CLIENT_QUESTIONS_LIST_SUCCESS,
  ADD_CLIENT_QUESTIONS_LIST_ERROR,

  UPDATE_CLIENT_TYPE,
  UPDATE_CLIENT_TYPE_SUCCESS,
  UPDATE_CLIENT_TYPE_ERROR,
  //new lead creation
  NEW_LEAD_CREATION,
  NEW_LEAD_CREATION_SUCCESS,
  NEW_LEAD_CREATION_ERROR,

  ADD_CLIENT_COMPLETE,
  ADD_CLIENT_COMPLETE_SUCCESS,
  ADD_CLIENT_COMPLETE_ERROR,

  ADD_CLIENT_APPEARANCE,
  ADD_CLIENT_APPEARANCE_SUCCESS,
  ADD_CLIENT_APPEARANCE_ERROR,

  UPDATE_ENGAGEMENT,
  UPDATE_ENGAGEMENT_SUCCESS,
  UPDATE_ENGAGEMENT_ERROR,

  UPDATE_HIGH_GOOD,
  UPDATE_HIGH_GOOD_SUCCESS,
  UPDATE_HIGH_GOOD_ERROR
}

export default constants
